import BoxActionButtons from "@components/BoxActionButtons";
import { ARTIST_DETAIL } from "@constants/routes";
import { ArtistVerified } from "@enums/artistVerified";
import { getArtistDisplayName } from "@helpers/artist.helper";
import { timestampToString } from "@helpers/dates.format";
import { getVerifiedIcon } from "@helpers/verified.helper";
import { IArtist } from "@interfaces/artist";
import BanIcon from "mdi-react/BanIcon";
import FeaturedIcon from "mdi-react/StarIcon";

const listArtistMapper = (items: IArtist[], handleModal: Function) =>
  items.map(
    ({
      uuid,
      artistName,
      ensName,
      walletAddress,
      verified,
      createdAt,
      banned,
      featured,
    }) => ({
      uuid,
      artistName: artistName ?? "-",
      ensName: ensName ?? "-",
      walletAddress,
      createdAt: timestampToString(createdAt),
      _createdAtTs: createdAt ?? 0,
      banned: banned ? (
        <span style={{ marginLeft: "25px" }}>
          <BanIcon style={{ width: "1.1rem", fill: "#e01d27" }} />
        </span>
      ) : (
        "-"
      ),
      verified:
        !verified || verified === ArtistVerified.NotVerified ? (
          "-"
        ) : (
          <img
            src={getVerifiedIcon(verified)}
            alt="verified"
            style={{ marginLeft: "25px" }}
          />
        ),
      featured: featured ? (
        <span style={{ marginLeft: "25px" }}>
          <FeaturedIcon style={{ width: "1.1rem" }} />
        </span>
      ) : (
        "-"
      ),
      actions: (
        <BoxActionButtons
          uuid={uuid}
          description={getArtistDisplayName(artistName, ensName, walletAddress)}
          handleModal={handleModal}
          detailUrl={ARTIST_DETAIL}
          isVerified={verified}
          isBanned={banned}
          isFeatured={featured}
        />
      ),
    })
  );

export default listArtistMapper;
